import _JSON$stringify from 'babel-runtime/core-js/json/stringify';
import _extends from 'babel-runtime/helpers/extends';
import getSlug from 'speakingurl';
import { progressModel } from '@rosetta/gaia-progress';

export var LOAD_ASSIGNED_COURSES = 'LOAD_ASSIGNED_COURSES';
export var SET_ASSIGNED_COURSES_AND_PROGRESS = 'SET_ASSIGNED_COURSES_AND_PROGRESS';
var UPDATE_ASSIGNED_COURSE_PROGRESS = 'UPDATE_ASSIGNED_COURSE_PROGRESS';

var SET_IS_ASSESSMENT = 'SET_IS_ASSESSMENT';

export var LOAD_AVAILABLE_COURSES = 'LOAD_AVAILABLE_COURSES';
var SET_AVAILABLE_COURSES = 'SET_AVAILABLE_COURSES';

export var ASSIGN_COURSE = 'ASSIGN_COURSE';
export var UNASSIGN_COURSE = 'UNASSIGN_COURSE';

var initialCourseState = {
  assignedCourses: null,
  // assignedCoursesProgress is kept here rather than in progress-reducer because
  //  it has different fields than the ProgressCourse data requested for a single course
  assignedCoursesProgress: null,
  isAssessment: false,
  availableCourses: null
};

export var courseReducer = function courseReducer() {
  var courseState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialCourseState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action && action.type) {
    // here is for actions that only want saga side-effects
    case LOAD_ASSIGNED_COURSES:
    case LOAD_AVAILABLE_COURSES:
    case ASSIGN_COURSE:
    case UNASSIGN_COURSE:
      return courseState;

    case SET_ASSIGNED_COURSES_AND_PROGRESS:
      var courses = null;
      var progress = null;
      if (action.payload.coursesAndProgress) {
        courses = action.payload.coursesAndProgress.assignedCourses;
        progress = action.payload.coursesAndProgress.progress;
      }
      return _extends({}, courseState, {
        assignedCourses: courses,
        assignedCoursesProgress: progress
      });

    case UPDATE_ASSIGNED_COURSE_PROGRESS:
      // keeps the assigned course progress info in synch when the current course (full) progress changes
      if (action.payload.courseProgress) {
        var newCoursesProgress = JSON.parse(_JSON$stringify(courseState.assignedCoursesProgress));
        if (!newCoursesProgress) {
          newCoursesProgress = [];
        }
        var courseProgressToUpdate = newCoursesProgress.find(function (assignedCourseProgress) {
          return assignedCourseProgress.courseId === action.payload.courseProgress.courseId;
        });
        // this course maybe did not have any progress yet
        if (!courseProgressToUpdate) {
          courseProgressToUpdate = {
            courseId: action.payload.courseProgress.courseId,
            countOfSequencesInCourse: action.payload.courseProgress.countOfSequencesInCourse
          };
          newCoursesProgress.push(courseProgressToUpdate);
        }
        courseProgressToUpdate.sequences = action.payload.courseProgress.sequences.map(function (seq) {
          return {
            id: seq.id,
            percentComplete: seq.percentComplete
          };
        });
        return _extends({}, courseState, {
          assignedCoursesProgress: newCoursesProgress
        });
      }
      return courseState;

    case SET_IS_ASSESSMENT:
      return _extends({}, courseState, {
        isAssessment: action.payload.isAssessment
      });

    case SET_AVAILABLE_COURSES:
      return _extends({}, courseState, {
        availableCourses: action.payload.availableCourses
      });

    default:
      return courseState;
  }
};

export var courseActions = {
  loadAssignedCoursesAndProgress: function loadAssignedCoursesAndProgress() {
    return { type: LOAD_ASSIGNED_COURSES };
  },
  setAssignedCoursesAndProgress: function setAssignedCoursesAndProgress(coursesAndProgress) {
    return {
      type: SET_ASSIGNED_COURSES_AND_PROGRESS,
      payload: { coursesAndProgress: coursesAndProgress }
    };
  },
  updateAssignedCourseProgress: function updateAssignedCourseProgress(courseProgress) {
    return {
      type: UPDATE_ASSIGNED_COURSE_PROGRESS,
      payload: { courseProgress: courseProgress }
    };
  },
  setIsAssessment: function setIsAssessment(isAssessment) {
    return {
      type: SET_IS_ASSESSMENT,
      payload: { isAssessment: isAssessment }
    };
  },
  loadAvailableCourses: function loadAvailableCourses() {
    return { type: LOAD_AVAILABLE_COURSES };
  },
  setAvailableCourses: function setAvailableCourses(availableCourses) {
    return {
      type: SET_AVAILABLE_COURSES,
      payload: { availableCourses: availableCourses }
    };
  },
  assignCourse: function assignCourse(courseId) {
    return { type: ASSIGN_COURSE, payload: { courseId: courseId } };
  },
  unassignCourse: function unassignCourse(courseId) {
    return { type: UNASSIGN_COURSE, payload: { courseId: courseId } };
  }
};

var getAssignedCourseBySlugOrId = function getAssignedCourseBySlugOrId(course, courseSlugOrId) {
  if (!course.assignedCourses) {
    return null;
  }
  return course.assignedCourses.find(function (assignedCourse) {
    return getSlug(assignedCourse.title) === courseSlugOrId || assignedCourse.id === courseSlugOrId;
  });
};

export var courseSelectors = {
  // Assume we are in an assessment until a legit Course indicates otherwise.
  getIsAssessment: function getIsAssessment(state) {
    return !state.course || state.course.isAssessment;
  },
  getAssignedCourses: function getAssignedCourses(state) {
    return state.course.assignedCourses;
  },
  getAvailableCourses: function getAvailableCourses(state) {
    return state.course.availableCourses;
  },
  getAssignedCourse: function getAssignedCourse(state, courseSlugOrId) {
    return getAssignedCourseBySlugOrId(state.course, courseSlugOrId);
  },
  getAllAssignedCoursesProgress: function getAllAssignedCoursesProgress(state) {
    return state.course.assignedCoursesProgress;
  },
  getAssignedCourseProgressInfo: function getAssignedCourseProgressInfo(state, courseSlugOrId) {
    var assignedCourse = getAssignedCourseBySlugOrId(state.course, courseSlugOrId);
    var courseProgress = null;
    if (assignedCourse) {
      if (state.course.assignedCoursesProgress) {
        courseProgress = state.course.assignedCoursesProgress.find(function (progress) {
          return progress.courseId === assignedCourse.id;
        });
      }
    }
    return progressModel.getCourseProgressInfo(courseProgress);
  },
  getAssignedCoursePercentComplete: function getAssignedCoursePercentComplete(state, courseSlugOrId) {
    var percentComplete = 0;
    var assignedCourse = getAssignedCourseBySlugOrId(state.course, courseSlugOrId);
    if (assignedCourse) {
      var courseProgress = null;
      if (state.course.assignedCoursesProgress) {
        courseProgress = state.course.assignedCoursesProgress.find(function (progress) {
          return progress.courseId === assignedCourse.id;
        });
      }
      percentComplete = progressModel.percentOfCompletedSequences(courseProgress);
    }
    return percentComplete;
  }
};